import "../css/FooterRequest.css";
import { Link } from "react-router-dom";

const FooterRequest = () => {
  return (
    <section className="FRContainer">
      <div className="Triangle"></div>
      <div className="FRContent">
        <h2 className="FRTitle">Share your project details with us.</h2>
        <Link to="/contact" className="FRButtonLink">
          <button className="FRSquareButton">Request a quote</button>
        </Link>
      </div>
    </section>
  );
};

export default FooterRequest;
